import config from '@/config'

export default {
  combine: {
    confirm_password: "Xác nhận @:ui.password",
    change_password: "Thay đổi @:ui.password",
    old_password: "Cũ @:ui.password",
    new_password: "@:ui.new @:ui.password",
    confirm_security_code: "Xác nhận @:ui.security_code",
    first_time_login: "Đăng Nhập Lần Đầu",
    security_authentication: "Xác Thực Bảo Mật",
    update_security: "Cập Nhật Bảo Mật",
    disable_security: "Vô Hiệu Hóa Bảo Mật",
    add_account: "Thêm Tài Khoản",
    add_sub_account: "Thêm Tài Khoản Phụ",
    edit_operator: "Chỉnh Sửa Người Vận Hành",
    edit_account: "Chỉnh Sửa Tài Khoản",
    edit_member: "Chỉnh Sửa Thành Viên",
    approve_ticket: "Phê Duyệt Vé",
    reject_ticket: "Từ Chối Vé",
    add_bank_account: "Thêm Tài Khoản Ngân Hàng",
    edit_bank_account: "Chỉnh Sửa Tài Khoản Ngân Hàng",
    reset_threshold: "Đặt Lại Ngưỡng",
    adjust_balance: "Điều Chỉnh Số Dư",
    adjust_member: "Điều Chỉnh Thành Viên",
    configure_bank_setting: "Cấu Hình Cài Đặt Ngân Hàng",
    account_setup: "Thiết Lập Tài Khoản",
    bank_transfer: "Chuyển Khoản Ngân Hàng",
    edit_bank_member: "Chỉnh Sửa Thành Viên Ngân Hàng",
    edit_ticket: "Chỉnh Sửa Vé",
    edit_vip: "Chỉnh Sửa VIP",
    knock_off_promo: "Khuyến Mãi Knock Off",
    edit_authority: "Chỉnh Sửa Quyền Hạn",
    reset_password: "Đặt lại mật khẩu",
    update_password: "Cập nhật mật khẩu",
    member_summary: "Tóm tắt thành viên",
    reply_review: "Phản hồi đánh giá",
    edit_affiliate: "Sửa liên kết",
    edit_bank_affiliate: "Sửa liên kết ngân hàng",
    approve_affiliate_ticket: "Phê duyệt vé liên kết",
    check_free_spin: "Kiểm tra quay miễn phí",
    reject_affiliate_ticket: "Từ chối vé liên kết",
    wallet_adjust: "Điều chỉnh ví",
    update_comm_package: "Cập nhật gói hoa hồng",
    approve_affiliate: "Phê duyệt liên kết",
    sub_acc_detail_affiliate: "Chi tiết tài khoản phụ liên kết",
    get_tac: "Lấy OTP",
    add_coupon: "Thêm Coupon",
    update_coupon: "Cập nhật Coupon",
    issue_free_spin: "Cấp Free Spin",
    get_bank_tac: "Lấy OTP Ngân hàng",
    update_global_setting: "Cập nhật Cài đặt Toàn cầu",
    add_platform: "Thêm Nền tảng",
    edit_platform: "Sửa Nền tảng",
    add_bank_group: "Thêm Nhóm Ngân hàng",
    edit_bank_group: "Sửa Nhóm Ngân hàng",
    update_maintenance_schedule: "Cập nhật Lịch bảo trì",
    add_withdrawal_limit: "Thêm Giới hạn Rút tiền",
    edit_withdrawal_limit: "Sửa Giới hạn Rút tiền",
    add_campaign: "Thêm Chiến Dịch",
    edit_campaign: "Sửa Chiến Dịch",
    add_promo_group: "Thêm Nhóm Khuyến Mãi",
    edit_promo_group: "Sửa Nhóm Khuyến Mãi",
    update_team: "Cập Nhật Đội",
    update_result: "Cập Nhật Kết Quả",
    insert_result: "Chèn Kết Quả",
    bet_list: "Danh Sách Cược",
    result_list: "Danh Sách Kết Quả",
    add_promo: "Thêm Khuyến Mãi",
    raise_deposit_ticket: "Tăng Vé Gửi Tiền",
    bank_adjust: "Điều Chỉnh Ngân Hàng",
    promo_member_assign: "Gán Thành Viên Khuyến Mãi",
    bonus_issue: "Phát Thưởng",
    update_vip: "Cập Nhật VIP",
    update_member_profile: "Cập Nhật Hồ Sơ Thành Viên",
    change_withdrawal_limit: "Thay Đổi Giới Hạn Rút Tiền",
    change_bank_group: "Thay Đổi Nhóm Ngân Hàng",
    change_promotion_group: "Thay Đổi Nhóm Khuyến Mãi",
    edit_promo_signup: "Sửa Đăng Ký Khuyến Mãi",
    update_provider_bet_limit: "Cập Nhật Giới Hạn Cược Nhà Cung Cấp",
    update_bet_limit: "Cập Nhật Giới Hạn Cược",
    update_member_bet_limit: "Cập Nhật Giới Hạn Cược Thành Viên",
    edit_bank_account_group: "Sửa Nhóm Tài Khoản Ngân Hàng",
    redeposit_ticket: "Tái Gửi Vé",
    edit_promotion_group: "Sửa Nhóm Khuyến Mãi",
    edit_promotion_group_norm: "Quản Lý Khuyến Mãi Trong Nhóm",
    get_inbox_list: "Lấy danh sách hộp thư đến",
    view_result_changes_detail: "Xem chi tiết thay đổi kết quả",
    edit_promotion_signup: "Chỉnh sửa đăng ký khuyến mãi",
    edit_bet_limit: "Chỉnh sửa giới hạn cược",
    edit_provider_game_off: "Chỉnh sửa trò chơi nhà cung cấp tắt",
    edit_provider_rtp: "Chỉnh sửa RTP nhà cung cấp",
    get_rebate: "Nhận Hoàn Tiền",
    get_recent_deposit: "Nhận Gửi Gần Đây",
    add_survey: "Thêm Khảo Sát",
    add_announcement_banner: "Thêm Biểu Ngữ Thông Báo",
    edit_announcement_banner: "Sửa Biểu Ngữ Thông Báo",
    move_announcement_banner: "Di Chuyển Biểu Ngữ Thông Báo",
    add_promotion_banner: "Thêm Biểu Ngữ Khuyến Mãi",
    edit_promotion_banner: "Sửa Biểu Ngữ Khuyến Mãi",
    move_promotion_banner: "Di Chuyển Biểu Ngữ Khuyến Mãi",
    add_slide_banner: "Thêm Biểu Ngữ Trượt",
    edit_slide_banner: "Sửa Biểu Ngữ Trượt",
    move_slide_banner: "Di Chuyển Biểu Ngữ Trượt",
    add_seo_page: "Thêm Trang SEO",
    edit_seo_page: "Sửa Trang SEO",
    clear_outstanding: "Xóa Nợ Đọng",
    add_ip_whitelist: "Thêm danh sách trắng IP",
    bonus_issue_bulk: "Phát hành thưởng hàng loạt",
    edit_bank_member_ewallet: "Chỉnh sửa thành viên ngân hàng (E-Wallet)",
    redeposit: "Nạp lại tiền",
    reject_approved_ticket: "Từ chối vé đã được phê duyệt",
    audit_ticket: "Kiểm toán vé",
    review_ticket: "Xem xét vé",
    edit_promotion_group_norm_seq: "Quản lý thứ tự khuyến mãi trong nhóm",
    edit_promo_provider_list: "Chỉnh sửa danh sách nhà cung cấp khuyến mãi",
    edit_promo_payment_option: "Chỉnh sửa tùy chọn thanh toán khuyến mãi",
    edit_campaign_provider_list: "Chỉnh sửa danh sách nhà cung cấp chiến dịch",
    update_comm: "Cập nhật hoa hồng",
    update_carry_over: "Cập nhật carry over",
    review_affiliate_ticket: "Xem xét vé liên kết",
    audit_affiliate_ticket: "Kiểm toán vé liên kết",
    get_tac_affiliate: "Lấy OTP (Liên kết)",
    raise_deposit_ticket_gateway: "Đặt Vé Gửi Tiền (Gateway)",
    direct_audit_ticket: "Kiểm Tra Vé (Trực Tiếp)",
    get_rollback_detail: "Lấy Chi Tiết Hoàn Tiền",
    get_reject_detail: "Lấy Chi Tiết Từ Chối",
    manual_approve_ticket: "Phê Duyệt Vé (Thủ Công)",
    add_label: "Thêm Nhãn",
    edit_label: "Sửa Nhãn",
    rollback_processing_ticket: "Vé Xử Lý Hoàn Tiền",
    update_iframe_url: "Cập Nhật URL Iframe",
    edit_exchange_rate: "Sửa Tỷ Giá",
    add_vip: "Thêm VIP",
    add_turnover_tier: "Thêm Bậc Doanh Thu",
    edit_turnover_tier: "Sửa Bậc Doanh Thu",
    get_member_label_list: "Danh sách Nhãn Thành viên",
    add_rescue_fund: "Thêm Quỹ Cứu Hộ",
    get_custom_member_list: "Danh sách Thành viên Tùy Chỉnh",
    get_rescue_fund_provider: "Lấy Nhà Cung Cấp Quỹ Cứu Hộ",
    add_game_exclude: "Thêm Game Loại Trừ",
    delete_game_exclude: "Xóa Trò Chơi Bị Loại Trừ",
    domain_custom_add_assign: "Thêm Miền",
    add_domain_batch: "Thêm Miền (Theo Lô)",
    update_payment_provider_vip: "Cập nhật Nhà Cung Cấp Thanh Toán Vip",
    update_campaign: "Cập nhật Chiến Dịch",
    purchase_domain: "Mua Miền",
    apply_domain: "Áp Dụng Miền",
    edit_access_control: "Chỉnh sửa quyền truy cập",
    add_domain: "Thêm miền",
    operator_wallet_adjust: "Điều chỉnh Ví của Nhà điều hành",
    update_payment_provider_desc: "Cập nhật Mô tả Nhà cung cấp Thanh toán",
    add_package: "@:ui.add @:ui.package",
    edit_package: "@:ui.edit @:ui.package",
    add_theme_content: "@:ui.add @:ui.theme_content",
    edit_theme_content: "@:ui.edit @:ui.theme_content",
    add_theme: "@:ui.add @:ui.theme",
    edit_theme: "@:ui.edit @:ui.theme",
    add_color: "@:ui.add @:ui.color",
    edit_color: "@:ui.edit @:ui.color",
    add_content: "@:ui.add @:ui.content",
    edit_content: "@:ui.edit @:ui.content",
    delete_content: "@:ui.delete @:ui.content",
    update_setting: "@:ui.update @:ui.setting",
    add_theme_content_group: "@:ui.add @:ui.theme_content_group",
    edit_theme_content_group: "@:ui.edit @:ui.theme_content_group",
    add_bo_default_domain: "@:ui.add @:ui.bo_default_domain",
    edit_bo_default_domain: "@:ui.edit @:ui.bo_default_domain",
    update_theme: "@:ui.update @:ui.theme",
    update_menu: "@:ui.update @:ui.menu",
    update_game_menu: "@:ui.update @:ui.game_menu",
    update_special_menu: "@:ui.update @:ui.special_menu",
    update_setting_menu: "@:ui.update @:ui.setting_menu",
    update_profile_setting: "@:ui.update @:ui.profile_setting",
    update_operator_setting: "@:ui.update @:ui.operator_setting",
    add_social_account: "@:ui.add @:ui.social_account",
    edit_social_account: "@:ui.edit @:ui.social_account",
    add_site_info: "@:ui.add @:ui.site_info",
    edit_site_info: "@:ui.edit @:ui.site_info",
    add_ads: "@:ui.add @:ui.advertisement",
    edit_ads: "@:ui.edit @:ui.advertisement",
    edit_provider_hot_game: "@:ui.edit @:ui.provider @:ui.hot_game",
    edit_provider_new_game: "@:ui.edit @:ui.provider @:ui.new_game",
    edit_provider_popular_game: "@:ui.edit @:ui.provider @:ui.popular_game",
    edit_provider_featured_game: "@:ui.edit @:ui.provider @:ui.featured_game",
    setup_logo: "Cài đặt Logo",
    add_livechat: "@:ui.add @:ui.livechat",
    update_livechat: "@:ui.update @:ui.livechat",
    provider_pt_operator_update: "Cập nhật Nhà điều hành PT của Nhà cung cấp",
    provider_pt_global_update: "Cập nhật Toàn cầu PT của Nhà cung cấp",
    payment_option_callback_update: "Cập nhật URL Callback",
    change_payment_option_seq: "Thứ tự Tùy chọn Thanh toán",
    change_payment_mode_status: "Cập nhật Trạng thái Tùy chọn Thanh toán",
    change_payment_option_recommend: "Đề xuất Tùy chọn Thanh toán",
    change_payment_option_credential: "Thông tin xác thực Tùy chọn Thanh toán",
    change_payment_option_limit: "Giới hạn Tùy chọn Thanh toán",
    change_payment_option_vip: "Tùy chọn Thanh toán VIP",
    add_mini_game: "@:ui.add @:ui.mini_game",
    edit_mini_game: "@:ui.edit @:ui.mini_game",
    add_mini_game_template: "@:ui.add @:ui.mini_game_template",
    edit_mini_game_template: "@:ui.edit @:ui.mini_game_template",
    edit_reward: "@:ui.edit @:ui.reward",
    gamify_update: "@:ui.update @:ui.reward",
    add_free_game_token: "@:ui.add @:ui.free_game_token",
    add_partners: "@:ui.add @:ui.partners",
    edit_partners: "@:ui.edit @:ui.partners",
  },
  short: {
    deposit_amount: "Số Tiền Gửi",
    base_amount: "Số tiền cơ bản",
    bonus_amount: "Số tiền thưởng",
    target_amount: "Số tiền mục tiêu",
    knockoff_by: "Bị K.O bởi",
    knockoff_date: "Ngày K.O",
    incoming_threshold: "TRONG NGƯỠNG",
    incoming_frequency: "TRONG TẦN SỐ",
    outgoing_threshold: "NGƯỠNG RA",
    outgoing_frequency: "OUT FREQ",
    account_balance: "ACC BAL",
    claim_type: "C.Type",
    bonus_rate: "Tỷ lệ B",
    max_bonus: "M.Bonus",
    rollover: "Rollover",
    criteria: "Tiêu chí",
    start_time: "S.Time",
    end_time: "E.Time",
    monday: "Thứ Hai",
    tuesday: "THU",
    wednesday: "THU",
    thursday: "THU",
    friday: "THU",
    saturday: "THỨ BẢY",
    sunday: "CHỦ NHẬT",
    status: "Trạng thái",
    bonus_rate_percent: "Tỷ lệ (%)",
    valid_turnover: "Doanh thu",
    deposit_count: "Số lượng gửi tiền",
    withdrawal_amount: "Số lượng cửa sổ",
    withdrawal_count: "Số lượng Wdw",
    adjustment_amount: "Số tiền điều chỉnh",
    referee_count: "Số lượng trọng tài",
    signup_count: "Số lượng đăng ký",
    verified_count: "Số lượng VRF",
    active_member: "Số lượng Mbm hoạt động",
    ftd_count: "Số lượng FTD",
    ftd_amount: "Số tiền FTD",
    working_date: "Số lượng DT đang làm việc",
    recipient_bank_id: "ID Ngân hàng R",
    recipient_bank_acc_no: "Số tài khoản Ngân hàng R",
    recipient_bank_acc_holder: "Chủ tài khoản Ngân hàng R",
    sender_bank: "Ngân hàng S",
    sender_bank_acc_no: "Số tài khoản Ngân hàng S",
    sender_bank_acc_holder: "Chủ tài khoản Ngân hàng S",
    unique_login_count: "Số lượng đăng nhập U",
    unique_deposit_count: "Nạp duy nhất",
    unique_withdrawal_count: "Số lượng cửa sổ U",
    second_deposit_count: "Số lượng gửi S",
    reject_date: "Ngày R",
    processing_date: "Ngày P",
    deposit_withdrawal_different: "Chênh lệch cửa sổ gửi",
    external_id: "ID Ex",
    draft_version: "Phiên bản Draft",
    prod_version: "Phiên bản Prod",
    purchased_date: "Ngày P",
    completed_amount: "Hoàn tất"
  },
  date_ranges: {
    0: "Hôm nay",
    1: "Hôm qua",
    2: "Tháng này",
    4: "Tháng trước",
  },
  langList: {
    EN: "Tiếng Anh",
    CN: "Tiếng Trung",
    PHP: "Philippines",
    esp: "Tiếng Tây Ban Nha",
    RUS: "Tiếng Nga"
  },
  menulist: {
    home: "Trang Chủ",
    hot: "Trò Chơi Nóng",
    slot_game: "Trò Chơi Slot",
    casino: "Casino",
    sportsbook: "Thể Thao",
    fishing: "Câu Cá",
    lottery: "Xổ Số",
    poker: "Poker",
    hash_game: "Trò Chơi Hash",
    sabong: "Sabong",
    promotion: "Khuyến Mãi",
    review: "Đánh Giá",
    news: "Tin Tức",
    live_stream: "Trực Tiếp",
    vip: "VIP",
    referral: "Giới Thiệu",
    favourite: "Yêu Thích",
    mission: "Nhiệm Vụ (Trò chơi nhỏ)",
    spin: "Quay",
    leaderboard: "Bảng Xếp Hạng",
    account: "Tài Khoản",
    deposit: "Gửi tiền",
    withdrawal: "Rút tiền",
    bet_history: "Lịch sử đặt cược",
    pending_status: "Trạng thái đang chờ",
    change_password: "Đổi mật khẩu",
    profile: "Hồ sơ",
    banking_details: "Chi tiết ngân hàng",
    inbox: "Hộp thư đến",
    voucher: "Phiếu quà tặng",
    wallet: "Ví",
    statement: "Bảng sao kê",
    download: "Tải xuống",
    game: "Trò chơi",
    special: "Đặc biệt",
    misc: "Khác",
    contact_us: "Liên hệ với chúng tôi",
    e_sportsbook: "Sách thể thao điện tử",
    lotto: "Lotto",
    p2p: "P2P",
    other: "Khác",
    vip2: "VIP2",
    referral2: "Giới thiệu2",
    event: "Sự kiện",
    daily_reward: "Phần thưởng hàng ngày",
    play2earn: "Chơi để kiếm",
    redemption: "Đổi thưởng",
    card_board: "Bảng thẻ",
    lobby: "Sảnh",
    in_house: "Tại chỗ",
    transfer: "Chuyển khoản",
    horse_racing: "Đua ngựa",
    register: "Đăng ký",
    login: "Đăng nhập",
    transaction_history: "Lịch sử giao dịch",
    bingo: "Bingo",
    member: "Thành viên",
    arcade: "Trò Chơi Điện Tử",
    crash: "Tên lửa cá cược"
  },

  ok: "Đồng ý",
  cancel: "Hủy",
  login: "Đăng nhập",
  logout: "Đăng xuất",
  add: "Thêm",
  edit: "Sửa",
  delete: "Xóa",
  refresh: "Làm mới",
  action: "Hành động",
  id: "Mã ID",
  name: "Tên",
  all: "Tất cả",
  search: "Tìm kiếm",
  remove: "Xóa bỏ",
  save: "Lưu",
  account: "Tài khoản",
  settings: "Cài đặt",
  on: "BẬT",
  off: "TẮT",
  new: "Mới",
  clear: "Xóa",
  users: "Người dùng | Người dùng",
  username: "Tên người dùng",
  password: "Mật khẩu",
  created_on: "Ngày tạo",
  active: "Kích hoạt",
  page_size: "Kích thước trang",
  status: "Trạng thái",
  result: "Kết quả",
  close: "Đóng",
  back: "Quay lại",
  show: "Hiện",
  login_id: "ID đăng nhập",
  date_time: "Ngày giờ",
  ip_address: "Địa chỉ IP",
  domain_name: "Tên miền",
  browser_agent: "Trình duyệt",
  action_by: "Hành động bởi",
  details: "Chi tiết",
  key: "Khóa | Khóa",
  value: "Giá trị | Giá trị",
  from: "Từ",
  to: "Đến",
  type: "Loại",
  criteria: "Tiêu chí",
  log: "Nhật ký",
  report: "Báo cáo",
  security_tag: "Thẻ bảo mật",
  security_code: "Mã bảo mật",
  submit: "Gửi",
  disable: "Vô hiệu hóa",
  operators: "Người điều hành | Người điều hành",
  members: "Thành viên",
  account_id: "ID tài khoản",
  confirm_password: "Xác nhận mật khẩu",
  full_name: "Họ và Tên",
  contact_phone: "Số Điện Thoại Liên Hệ",
  contact_email: "Email Liên Hệ",
  dashboard: "Bảng Điều Khiển",
  sub_account: "Tài Khoản Phụ",
  authority_option: "Tùy chọn quyền hạn",
  banks: "Ngân Hàng | Ngân Hàng",
  login_ip : "Địa Chỉ IP Đăng Nhập",
  block: "Chặn",
  profile_id: "Mã Hồ Sơ",
  suspend: "Đình Chỉ",
  dob: "Ngày Sinh",
  mail_address: "Địa Chỉ Thư",
  deposit: "Gửi Tiền",
  withdrawal: "Rút Tiền",
  rejected: "Từ Chối",
  processed: "Đã Xử Lý",
  pending: "Đang Chờ",
  member: "Thành Viên",
  amount: "Số Tiền",
  bank_acc_no: "Số Tài Khoản Ngân Hàng",
  deposit_date: "Ngày Gửi Tiền",
  deposit_method: "Phương Thức Gửi Tiền",
  approve: "Phê Duyệt",
  reject: "Từ Chối",
  remark: "Ghi Chú",
  ticket_detail: "Chi Tiết Vé",
  promo: "Khuyến Mãi",
  package: "Gói",
  created_date: "Ngày Tạo",
  currency: "Tiền Tệ",
  bank_acc_holder: "Chủ Tài Khoản Ngân Hàng",
  ref_no: "Số Tham Chiếu",
  vip: "VIP",
  modified_date: "Ngày Chỉnh Sửa",
  modified_by: "Được Chỉnh Sửa Bởi",
  bank_member: "Thành Viên Ngân Hàng",
  bank_operator: "Nhân Viên Ngân Hàng",
  bank_name: "Tên Ngân Hàng",
  bank_acc_type: "Loại Tài Khoản Ngân Hàng",
  account_balance: "Số Dư Tài Khoản",
  threshold: "Ngưỡng",
  incoming: "Đến",
  outgoing: "Đi",
  frequency: "Tần Suất",
  reset_threshold: "Đặt Lại Ngưỡng",
  adjust_balance: "Điều Chỉnh Số Dư",
  bank_from: "Ngân Hàng Từ",
  bank_to: "Ngân Hàng Đến",
  attachment: "Tệp Đính Kèm",
  sender_bank: "Ngân Hàng Gửi",
  sender_bank_acc_no: "Số Tài Khoản Ngân Hàng Người Gửi",
  sender_bank_acc_holder: "Chủ Tài Khoản Ngân Hàng Gửi",
  audit: "Kiểm toán",
  action_status: "Tình trạng hành động",
  action_date: "Ngày hành động",
  promotion: "Khuyến mãi",
  promo_id: "Mã khuyến mãi",
  promo_name: "Tên khuyến mãi",
  package_id: "Mã gói",
  claim_type: "Loại yêu cầu",
  bonus_rate: "Tỷ lệ thưởng",
  max_bonus: "Tối đa thưởng",
  rollover: "Chuyển đổi",
  start_date: "Ngày bắt đầu",
  end_date: "Ngày kết thúc",
  adj_amount: "Số tiền điều chỉnh",
  promotion_member: "Thành viên khuyến mãi",
  on_going: "Đang diễn ra",
  knock_off: "Knock Off",
  all_ongoing: "Tất cả Đang diễn ra",
  deposit_amount: "Số tiền gửi",
  base_amount: "Số tiền Cơ bản",
  bonus_amount: "Số tiền Thưởng",
  target_amount: "Số tiền Mục tiêu",
  claim_date: "Ngày yêu cầu",
  accumulate_win: "Tích lũy Thắng",
  accumulate_turnover: "Tích lũy Doanh thu",
  bonus: "Thưởng",
  bonus_log: "Nhật ký Thưởng",
  member_id: "Mã Thành viên",
  before_balance: "Số dư Trước",
  transfer_amount: "Số tiền Chuyển",
  after_balance: "Sau Cân bằng",
  created_by: "Người Tạo",
  bonus_name: "Tên Thưởng",
  bonus_desc: "Mô tả Thưởng",
  bonus_type: "Loại Thưởng",
  add_promo: "Thêm Khuyến mãi",
  bonus_value: "Giá trị Thưởng",
  attach_promo: "Gắn Khuyến mãi",
  daily_statement: "Báo cáo Hàng ngày",
  working_date: "Ngày làm việc",
  opening_balance: "Số dư Mở",
  turnover: "Doanh thu",
  valid_turnover: "Doanh thu Hợp lệ",
  winlose: "ThắngThua",
  withdrawal_amount: "Số tiền Rút",
  closing_balance: "Số dư Đóng",
  sub_total: "Tổng phụ",
  grand_total: "Tổng cộng",
  daily_winlose: "ThắngThua Hàng ngày",
  game_result_slots: "Kết quả trò chơi (Slots)",
  game_result_livecasino: "Kết quả trò chơi (Livecasino)",
  game_result_rebate: "Kết quả trò chơi (Rebate)",
  game_result_sportsbook: "Kết quả trò chơi (Sportsbook)",
  game_result_cockfight: "Kết quả trò chơi (Cockfight)",
  game_result_rescue: "Kết quả trò chơi (Rescue)",
  bet_count: "Số lần đặt cược",
  result_id: "Mã kết quả",
  bet_time: "Thời gian đặt cược",
  payout: "Trả thưởng",
  game_type: "Loại trò chơi",
  game_name: "Tên trò chơi",
  game_provider: "Nhà cung cấp trò chơi",
  reset: "Đặt lại",
  mode: "Chế độ",
  balance: "Số dư",
  min_bal_knock_off_promo: "Số dư tối thiểu (Để tự động hủy khuyến mãi)",
  social_account: "Tài khoản xã hội",
  wechat: "Wechat",
  telegram: "Telegram",
  whatsapp: "Whatsapp",
  facebook: "Facebook",
  instagram: "Instagram",
  login_log: "Nhật ký đăng nhập",
  platform: "Nền tảng",
  bank_statement: "Thông báo ngân hàng",
  transfer_date: "Ngày chuyển khoản",
  detail: "Chi tiết",
  date: "Ngày",
  transfer_list: "Danh sách chuyển khoản",
  credit: "Tín dụng",
  debit: "Nợ",
  month: "Tháng",
  unblock: "Giải phóng",
  unblock_member: "Giải phóng Thành viên",
  unblock_operator: "Giải phóng Nhà điều hành",
  referrer_id: "Mã Người giới thiệu",
  referrer_code: "Mã Người giới thiệu",
  referral_code: "Mã Giới thiệu",
  bonus_and_adjustment: "Thưởng & Điều chỉnh",
  adjustment: "Điều chỉnh",
  incoming_amount_threshold: "Ngưỡng Số tiền đến",
  outgoing_amount_threshold: "Ngưỡng Số tiền đi",
  knock_off_by: "Được xóa bởi",
  knock_off_date: "Ngày xóa",
  total_turnover: "Tổng Doanh thu",
  total_winlose: "Tổng Thắng thua",
  total_deposit: "Tổng Gửi",
  total_member: "Tổng Thành viên",
  active_player: "Người chơi Hoạt động",
  top_winner: "Người thắng lớn nhất",
  top_loser: "Người thua lớn nhất",
  winner: "Người thắng",
  loser: "Người thua",
  deposit_count: "Số lần gửi tiền",
  withdrawal_count: "Số lần rút tiền",
  alert: "Cảnh báo",
  incoming_threshold: "Ngưỡng tiền vào",
  incoming_frequency: "Tần suất tiền vào",
  outgoing_threshold: "Ngưỡng tiền ra",
  outgoing_frequency: "Tần suất tiền ra",
  reset_password: "Đặt lại mật khẩu",
  transfer: "Chuyển khoản",
  company_bank: "Ngân hàng công ty",
  company_bank_acc_no: "Số Tài Khoản Ngân Hàng Công Ty",
  company_bank_acc_holder: "Chủ Tài Khoản Ngân Hàng Công Ty",
  registered_member: "Thành Viên Đã Đăng Ký",
  promotion_report: "Báo Cáo Khuyến Mãi",
  deposited_member: "Thành Viên Đã Gửi Tiền",
  referred_member: "Thành Viên Giới Thiệu",
  validated_on: "Đã Xác Nhận Vào",
  first_deposit: "Gửi Tiền Đầu Tiên",
  reward: "Phần Thưởng",
  inbox: "Hộp Thư",
  manual_bonus: "Thưởng Thủ Công",
  review: "Đánh Giá | Đánh Giá",
  reviews: "Đánh Giá",
  review_list: "Danh Sách Đánh Giá",
  review_detail: "Chi Tiết Đánh Giá",
  reply_review: "Phản Hồi Đánh Giá",
  comment: "Bình Luận",
  reply: "Phản Hồi",
  recipient_no: "Số Người Nhận",
  question : "Câu Hỏi",
  rating: "Đánh Giá",
  content: "Nội Dung",
  image: "Hình Ảnh",
  monthly_rating: "Đánh Giá Hàng Tháng",
  affiliate: "Đối Tác",
  affiliate_list: "Danh Sách Đối Tác",
  affiliate_code: "Mã Đối Tác",
  approved_by: "Được Phê Duyệt Bởi",
  approved_date: "Ngày Phê Duyệt",
  bank_affiliate: "Đối Tác Ngân Hàng",
  bank_id: "Mã Ngân Hàng",
  ticket_detail_affiliate: "Chi Tiết Vé Đối Tác",
  pending_application: "Đơn Đang Chờ",
  pending_review_withdrawal: "Rút Tiền Đang Chờ & Đánh Giá",
  unblock_affiliate: "Bỏ Chặn Đối Tác",
  wallet_adjust: "Điều chỉnh Ví",
  comm_package: "Gói Hoa Hồng",
  affiliate_id: "Mã ID Đối Tác",
  sub_account_detail: "Chi Tiết Tài Khoản Phụ",
  daily_winlose_affiliate: "Thắng Thua Hàng Ngày (Đối Tác)",
  daily_deposit_affiliate: "Gửi Tiền Hàng Ngày (Đối Tác)",
  export_excel: "Xuất Excel",
  get_tac: "Lấy OTP",
  tac_code: "Mã OTP",
  expiry_date: "Ngày hết hạn",
  inactive: "Không hoạt động",
  last_deposit_date: "Ngày gửi tiền cuối cùng",
  coupon: "Phiếu giảm giá",
  allocated: "Đã phân bổ",
  claimed: "Đã yêu cầu",
  approved: "Đã phê duyệt",
  coupon_code: "Mã phiếu giảm giá",
  coupon_quota: "Quota phiếu giảm giá",
  current_allocated: "Đã phân bổ hiện tại",
  new_allocated: "Đã phân bổ mới",
  update : "Cập nhật",
  copy: "Sao chép",
  bonus_rate_percent : "Tỷ lệ thưởng (%)",
  coupon_desc: "Mô tả phiếu giảm giá",
  both: "Cả hai",
  issue_free_spin: "Cấp Vòng Quay Miễn Phí",
  game: "Trò Chơi",
  max_win_amount: "Số Tiền Thắng Tối Đa",
  utm_list: "Danh Sách UTM",
  search_by_member: "Tìm Kiếm Theo Thành Viên",
  campaign: "Chiến Dịch",
  deposited: "Đã Nạp",
  search_by_id: "Tìm Kiếm Theo ID",
  get_bank_tac: "Lấy OTP Ngân Hàng",
  bank_statement_daily: "Bảng Sao Kê Ngân Hàng (Hàng Ngày)",
  transfer_type: "Loại Chuyển Khoản",
  audit_freebies_list: "Danh Sách Quà Tặng Kiểm Toán",
  acknowledge: "Xác Nhận",
  submit_acknowledgement: "Gửi Xác Nhận",
  is_ack: "Có Xác Nhận",
  yes: "Có",
  no: "Không",
  audit_rescue_fund_list: "Danh sách Quỹ Cứu trợ Kiểm toán",
  global_setting: "Cài đặt Toàn cầu",
  signup_ip: "IP Đăng ký",
  last_login_ip: "IP Đăng nhập Cuối cùng",
  last_login_time: "Thời gian Đăng nhập Cuối cùng",
  link: "Liên kết",
  is_default: "Mặc định",
  is_public: "Công khai",
  bank_group: "Nhóm Ngân hàng",
  set_default: "Đặt Mặc định",
  group_id: "ID Nhóm",
  group_name: "Tên Nhóm",
  provider_maintenance: "Bảo trì Nhà cung cấp",
  provider_code: "Mã Nhà cung cấp",
  provider_name: "Tên Nhà cung cấp",
  withdrawal_limit: "Giới hạn Rút tiền",
  limit_id: "ID Giới hạn",
  limit_name: "Tên Giới hạn",
  daily_amount: "Số tiền Hàng ngày",
  daily_frequency: "Tần suất Hàng ngày",
  promotion_id: "ID Khuyến mãi",
  promotion_name: "Tên Khuyến mãi",
  withhold_bonus: "Khấu trừ Thưởng",
  withhold_amount: "Số tiền Khấu trừ",
  withhold_amt: "Số tiền Khấu trừ",
  max_withdraw_amt: "Số tiền Rút tối đa",
  max_withdraw_amount: "Số tiền Rút tối đa",
  monday: "Thứ Hai",
  tuesday: "Thứ Ba",
  wednesday: "Thứ Tư",
  thursday: "Thứ Năm",
  friday: "Thứ Sáu",
  saturday: "Thứ Bảy",
  sunday: "Chủ Nhật",
  start_time: "Thời gian bắt đầu",
  end_time: "Thời gian kết thúc",
  day: "Ngày | Ngày",
  coupon_status: "Trạng thái phiếu giảm giá",
  campaign_id: "ID chiến dịch",
  campaign_name: "Tên chiến dịch",
  promotion_group: "Nhóm khuyến mãi",
  referee_list: "Danh sách trọng tài",
  account_verified: "Tài khoản đã xác minh",
  verified_date: "Ngày xác minh",
  ticket_list: "Danh sách vé",
  vip_id: "ID VIP",
  vip_name: "Tên VIP",
  self_rebate_rate: "Tỷ lệ hoàn tiền tự động (%)",
  downline_rebate_rate: "Tỷ lệ hoàn tiền tuyến dưới (%)",
  provider: "Nhà cung cấp",
  match_id: "ID trận đấu",
  home_team: "Đội nhà",
  away_team: "Đội khách",
  home_team_new: "Đội nhà mới",
  away_team_new: "Đội khách mới",
  updated_by: "Người cập nhật",
  updated_on: "Ngày cập nhật",
  home_score: "Điểm Nhà",
  away_score: "Điểm Khách",
  home_score_new: "Điểm đội nhà mới",
  away_score_new: "Điểm đội khách mới",
  team: "Đội",
  match_time: "Thời Gian Trận Đấu",
  match_round: "Vòng đấu",
  home_group: "Nhóm đội nhà",
  away_group: "Nhóm đội khách",
  match: "Trận đấu",
  match_status: "Trạng thái trận đấu",
  insert: "Chèn",
  pin: "Ghim",
  bet_list: "Danh sách cược",
  result_list: "Danh sách kết quả",
  bet_id: "ID cược",
  bet_home: "Cược đội nhà",
  bet_away: "Cược đội khách",
  bet_on: "Đặt Cược",
  min_deposit: "Số tiền gửi tối thiểu",
  min_withdrawal: "Rút Tiền Tối Thiểu",
  raise_deposit_ticket: "Tăng Phiếu Gửi Tiền",
  method: "Phương Thức",
  one_time_depositor: "Người Gửi Tiền Một Lần",
  current_month_non_depositor: "Người Không Gửi Tiền Trong Tháng Hiện Tại",
  current_month_no_login: "Người Không Đăng Nhập Trong Tháng Hiện Tại",
  ticket_date: "Ngày Phiếu",
  ftd_amount: "Số Tiền FTD",
  bonus_issue: "Vấn Đề Thưởng",
  promotion_summary: "Tóm Tắt Khuyến Mãi",
  promotion_summary_detail: "Tóm Tắt Khuyến Mãi (Chi Tiết)",
  claim_frequency: "Tần Suất Yêu Cầu",
  provider_list: "Danh Sách Nhà Cung Cấp",
  platform_winlose: "Thắng Thua Nền Tảng",
  adjustment_amount: "Số Tiền Điều Chỉnh",
  referee_count: "Số Lượng Người Giới Thiệu",
  category: "Danh Mục",
  update_vip: "Cập Nhật VIP",
  promotion_signup: "Đăng Ký Khuyến Mãi",
  provider_bet_limit: "Giới Hạn Cược Nhà Cung Cấp",
  update_member_bet_limit: "Cập Nhật Giới Hạn Cược Thành Viên",
  bet_limit: "Giới Hạn Cược",
  sports_game: "Thể Thao/Trò Chơi",
  league_name: "Tên Giải Đấu",
  home_team_name: "Tên Đội Nhà",
  away_team_name: "Tên Đội Khách",
  wl_status: "Trạng Thái Thắng Thua",
  available_bank_account: "Tài Khoản Ngân Hàng Có Sẵn",
  group_bank_account: "Tài Khoản Ngân Hàng Nhóm",
  edit_bank_group: "Chỉnh Sửa Nhóm Ngân Hàng",
  edit_bank_account_group: "Chỉnh Sửa Nhóm Tài Khoản Ngân Hàng",
  redeposit: "Gửi Tiền Lại",
  upline: "Người Giới Thiệu",
  downline: "Người Được Giới Thiệu",
  available_promotion: "Khuyến Mãi Có Sẵn",
  group_promotion: "Khuyến Mãi Nhóm",
  edit_promotion_group: "Chỉnh Sửa Nhóm Khuyến Mãi",
  edit_promotion_group_norm: "Quản Lý Khuyến Mãi Trong Nhóm",
  balance_before: "Số Dư Trước",
  balance_after: "Số Dư Sau",
  signup_count: "Số Lượng Đăng Ký",
  verified_count: "Số Lượng Đã Xác Minh",
  active_member: "Thành Viên Hoạt Động",
  ftd_count: "Số Lượng FTD",
  daily_summary_company: "Tóm Tắt Hàng Ngày (Công Ty)",
  daily_summary_operator: "Tóm Tắt Hàng Ngày (Nhà Vận Hành)",
  daily_summary_member: "Tóm Tắt Hàng Ngày (Thành Viên)",
  daily_ledger_operator: "Sổ Cái Hàng Ngày (Nhà Vận Hành)",
  bonus_list: "Danh Sách Thưởng",
  ltd_date: "Ngày LTD",
  adjustment_log: "Nhật Ký Điều Chỉnh",
  get_inbox: "Nhận Hộp Thư",
  is_claimed: "Đã Yêu Cầu",
  mix_parlay: "Mix Parlay",
  event: "Sự kiện",
  result_changes_log: "Nhật ký thay đổi kết quả",
  view_detail: "Xem chi tiết",
  total_referee: "Tổng trọng tài",
  verified_signup: "Đã xác minh / Đăng ký",
  ftd: "FTD | Gửi tiền lần đầu",
  raw_msg: "Tin nhắn thô",
  unselect_all: "Bỏ chọn tất cả",
  select_all: "Chọn tất cả",
  edit_bet_limit: "Chỉnh sửa giới hạn cược",
  provider_game_off: "Trò chơi nhà cung cấp tắt",
  provider_hot_game: "Trò chơi nóng nhà cung cấp",
  game_id : "Mã trò chơi",
  game_list: "Danh sách trò chơi",
  off_list: "Danh sách tắt",
  provider_rtp: "RTP nhà cung cấp",
  rtp: "RTP",
  signup_date: "Ngày đăng ký",
  free_credit: "Tín dụng miễn phí",
  downline_rebate: "Hoàn Tiền Dưới Cấp",
  game_rebate: "Hoàn Tiền Trò Chơi",
  rebate: "Hoàn Tiền",
  ftd_date: "Ngày FTD",
  provider_winlose_company: "Nhà Cung Cấp Thắng Thua (Công Ty)",
  provider_winlose_operator: "Nhà Cung Cấp Thắng Thua (Nhà Điều Hành)",
  already_hit: "Đã Được Nhận",
  ongoing: "Đang Diễn Ra",
  members_export: "Thành Viên (Xuất)",
  get_recent_deposit: "Nhận Giao Dịch Gần Đây",
  recent_deposit: "Giao Dịch Gần Đây",
  survey_list: "Danh Sách Khảo Sát",
  modified_on: "Đã Chỉnh Sửa Vào",
  cms: "CMS",
  announcement_banner: "Biểu Ngữ Thông Báo",
  promotion_banner: "Biểu Ngữ Khuyến Mãi",
  slide_banner: "Biểu Ngữ Trượt",
  seo_page: "Trang SEO",
  en_title: "Tiêu Đề (EN)",
  cn_title: "Tiêu Đề (CN)",
  local_title: "Tiêu Đề (ĐỊA PHƯƠNG)",
  en_img: "Hình Ảnh (EN)",
  cn_img: "Hình Ảnh (CN)",
  local_img: "Hình Ảnh (ĐỊA PHƯƠNG)",
  before_login: "Trước Đăng Nhập",
  after_login: "Sau Đăng Nhập",
  en: "EN",
  move_up: "Di Chuyển Lên",
  move_down: "Di Chuyển Xuống",
  banner_type: "Loại Biểu Ngữ",
  default_order: "Thứ Tự Mặc Định",
  item_order: "Thứ Tự Mục",
  title: "Tiêu Đề",
  banner_id: "Mã Biểu Ngữ",
  order: "Thứ Tự",
  body: "Nội Dung",
  en_image: "Hình Ảnh (EN)",
  local_image: "Hình Ảnh (ĐỊA PHƯƠNG)",
  move: "Di Chuyển",
  en_img_desktop: "Hình Ảnh Máy Tính (EN)",
  cn_img_desktop: "Hình Ảnh Máy Tính (CN)",
  local_img_desktop: "Hình Ảnh Máy Tính (ĐỊA PHƯƠNG)",
  en_img_mobile: "Hình Ảnh Di Động (EN)",
  cn_img_mobile: "Hình Ảnh Di Động (CN)",
  local_img_mobile: "Hình Ảnh Di Động (ĐỊA PHƯƠNG)",
  login_required: "Cần Đăng Nhập",
  new_window_tab: "Cửa Sổ / Tab Mới",
  current_page: "Trang Hiện Tại",
  target: "Mục Tiêu",
  alt: "Alt",
  href: "Href",
  image_desktop: "Hình Ảnh Máy Tính",
  image_mobile: "Hình Ảnh Di Động",
  en_alt: "Alt (EN)",
  local_alt: "Alt (ĐỊA PHƯƠNG)",
  en_href: "Href (EN)",
  local_href: "Href (ĐỊA PHƯƠNG)",
  en_image_desktop: "Hình Ảnh Máy Tính (EN)",
  active_period: "Thời Gian Hoạt Động",
  en_item: "Mục (EN)",
  local_item: "Mục (ĐỊA PHƯƠNG)",
  meta_title: "Tiêu đề Meta",
  meta_keywords: "Từ khóa Meta",
  meta_url: "URL Meta",
  meta_canonical: "Canonical Meta",
  meta_author: "Tác giả Meta",
  meta_publisher: "Nơi xuất bản Meta",
  meta_lang: "Ngôn ngữ Meta",
  meta_desc: "Meta Desc",
  meta_image: "Meta Image",
  page: "Page",
  item: "Item",
  remove_desktop_image: "Remove Desktop Image",
  remove_mobile_image: "Remove Mobile Image",
  page_name: "Page Name",
  login_date: "Login Date",
  ftd_amount_min: "Min. FTD Amount",
  ftd_amount_max: "Max. FTD Amount",
  fl_provider_code: "First Launch Provider",
  fl_game_id: "First Launch Game ID",
  fl_game_name: "First Launch Game Name",
  top_deposit: "Top Deposit",
  top_withdrawal: "Top Withdrawal",
  top_promotion: "Top Promotion",
  outstanding_balance: "Outstanding Balance",
  last_update_time: "Last Update Time",
  trace: "Trace",
  trace_outstanding: "Trace Outstanding",
  outstanding: "Outstanding",
  clear_outstanding: "Clear Outstanding",
  meta_image_url: "Meta Image Url",
  member_bonus: "Member Bonus",
  crm_list: "CRM List",
  advance_search: "Advance Search",
  deposit_count_from: "Số lần gửi tiền từ",
  deposit_count_to: "Số lần gửi tiền đến",
  deposit_amount_from: "Số tiền gửi từ",
  deposit_amount_to: "Số tiền gửi đến",
  min_day_no_login: "Số ngày không đăng nhập tối thiểu",
  min_day_no_deposit: "Số ngày không gửi tiền tối thiểu",
  last_login: "Lần đăng nhập cuối",
  last_deposit: "Lần gửi tiền cuối",
  phone: "Điện thoại",
  email: "Email",
  ip_whitelist: "Danh sách trắng IP",
  ip: "IP",
  payment_option: "Tùy chọn thanh toán",
  payment_mode: "Phương thức thanh toán",
  payment_desc: "Mô tả thanh toán",
  success: "THÀNH CÔNG",
  failed: "THẤT BẠI",
  bank_member_ewallet: "Thành viên ngân hàng (E-Wallet)",
  processing: "Đang xử lý",
  recipient_bank_id: "Mã Ngân Hàng Người Nhận",
  recipient_bank_acc_no: "Số Tài Khoản Ngân Hàng Người Nhận",
  ticket_auto_withdrawal_log: "Nhật Ký Vé (Rút Tiền Tự Động)",
  resubmit_ticket: "Gửi Lại Vé",
  ticket_export: "Vé (Xuất)",
  export_deposit: "Xuất (Gửi Tiền)",
  export_deposit_all: "Xuất Tất Cả (Gửi Tiền)",
  export_withdrawal: "Xuất (Rút Tiền)",
  export_withdrawal_all: "Xuất Tất Cả (Rút Tiền)",
  export_member_all: "Xuất Tất Cả (Thành Viên)",
  processed_rejected: "Đã Xử Lý (Bị Từ Chối)",
  channel: "Kênh",
  influencer: "Người Ảnh Hưởng",
  ticket_id: "Mã Vé",
  recommend: "Gợi Ý",
  sequence: "Thứ Tự",
  statement_info: "Thông Tin Sao Kê",
  slots: "Các Khe",
  livecasino: "Casino Trực Tuyến",
  sportsbook: "Sòng Bạc Thể Thao",
  cockfight: "Đá Gà",
  member_list: "Danh Sách Thành Viên",
  operator: "Nhà Điều Hành",
  game_balance: "Số Dư Trò Chơi",
  claim_limit: "Hạn Mức Yêu Cầu",
  max_withdraw_multiple: "Số Lần Rút Tối Đa",
  payment_gateway: "Cổng thanh toán",
  min_limit: "Giới hạn tối thiểu",
  max_limit: "Giới hạn tối đa",
  total: "Tổng",
  rebate_summary: "Tóm tắt chiết khấu",
  rebate_summary_daily: "Tóm tắt giảm giá hàng ngày",
  rebate_member: "Thành viên giảm giá",
  self: "Bản thân",
  system_balance: "Cân bằng hệ thống",
  rejected_onload: "Bị từ chối (Đang tải)",
  no_bonus: "Không có tiền thưởng",
  audit_ticket: "Phiếu kiểm toán",
  review_ticket: "Vé đánh giá",
  edit_promotion_group_norm_seq: "Quản lý trình tự thăng tiến trong nhóm",
  signup_bonus: "Tiền thưởng đăng ký",
  settlement_type: "Loại thanh toán",
  carry_over: "Carry Over",
  comm_sports: "Ủy ban (Thể thao)",
  comm_slots: "Ủy ban (Slots)",
  comm_livecasino: "Ủy ban (Livecasino)",
  comm_cockfight: "Ủy ban (Đấu gà)",
  comm_others: "Ủy ban (Khác)",
  update_comm: "Cập nhật hoa hồng",
  update_carry_over: "Cập nhật chuyển tiếp",
  ewallet: "Ví điện tử",
  withdrawal_list: "Danh sách rút tiền",
  audit_withdrawal: "Rút kiểm toán",
  daily_withdrawal: "Rút tiền hàng ngày",
  adjustment_log_affiliate: "Nhật ký điều chỉnh",
  daily_statement_affiliate: "Tuyên bố hàng ngày (Chi nhánh)",
  earning: "Kiếm tiền",
  pnl: "P&L",
  review_affiliate_ticket: "Đánh giá vé liên kết",
  audit_affiliate_ticket: "Vé liên kết kiểm toán",
  turnover_downline: "Doanh thu (Hạ tuyến)",
  valid_turnover_downline: "Doanh thu hợp lệ (Hạ tuyến)",
  winlose_downline: "WinLose (Hạ tuyến)",
  bet_count_downline: "Đếm cược (Hạ tuyến)",
  turnover_member: "Doanh thu (Thành viên)",
  valid_turnover_member: "Doanh thu hợp lệ (Thành viên)",
  winlose_member: "WinLose (Thành viên)",
  bet_count_member: "Đếm cược (Thành viên)",
  dashboard_affiliate: "Bảng điều khiển (Chi nhánh)",
  total_agent: "Đại lý tổng thể",
  top_turnover: "Doanh thu cao nhất",
  bonus_count: "Đếm tiền thưởng",
  deposit_amount_downline: "Số tiền gửi (Hạ tuyến)",
  deposit_count_downline: "Số tiền gửi (Hạ tuyến)",
  bonus_amount_downline: "Số tiền thưởng (Hạ tuyến)",
  bonus_count_downline: "Đếm tiền thưởng (Hạ tuyến)",
  deposit_amount_member: "Số tiền gửi (Thành viên)",
  deposit_count_member: "Số tiền gửi (Thành viên)",
  bonus_amount_member: "Số tiền thưởng (Thành viên)",
  bonus_count_member: "Số tiền thưởng (Thành viên)",
  verified: "Đã xác minh",
  round_id: "ID vòng",
  unfinish_round: "Vòng chưa kết thúc",
  smartico_bonus_report: "Báo cáo tiền thưởng thông minh",
  unclaimed_amount: "Số tiền không được yêu cầu",
  claimed_amount: "Số tiền yêu cầu",
  unclaimed_count: "Bá tước không có người nhận",
  claimed_count: "Bá tước được yêu cầu",
  submit_time: "Ngày tạo",
  deposit_time: "Ngày sửa đổi",
  funds_list: "Danh sách vé",
  daifu_list_auto_withdrawal: "Danh sách vé (Rút vé tự động)",
  btn_href: "Nút Href",
  btn_text: "Văn bản nút",
  recent_inbox_claim: "Yêu cầu hộp thư đến gần đây",
  raise_deposit_ticket_gateway: "Tăng vé đặt cọc (Cổng)",
  gateway_acc: "Tài khoản cổng",
  provider_winlose_member: "Nhà cung cấp Winlose (Thành viên)",
  review_by: "Đánh giá của",
  daifu_list_auto_withdrawal_export: "Xuất vé (Rút vé tự động)",
  retention: "Retenton",
  current_month_active_user: "Người dùng hoạt động trong tháng hiện tại",
  current_month_active: "Tháng hiện tại đang hoạt động",
  first_month: "Tháng đầu tiên",
  fmwinlose: "FMWinlose",
  fmdeposit_amount: "Số tiền gửi FMD",
  cohort: "Đoàn hệ",
  promotion_withdrawal_summary: "Tóm tắt rút tiền khuyến mãi",
  unique_player: "Người chơi độc đáo",
  year: "Năm | Năm",
  audit_time_modified: "Ngày sửa đổi",
  audit_time_created: "Ngày tạo",
  approve_time: "Ngày sửa đổi",
  unique_login_count: "Số lượng đăng nhập duy nhất",
  unique_deposit_count: "Số lần nạp tiền duy nhất",
  unique_withdrawal_count: "Số lần rút tiền duy nhất",
  second_deposit_count: "Số tiền gửi thứ hai",
  unique_login: "Đăng nhập duy nhất",
  unique_withdrawal: "Rút tiền duy nhất",
  second_deposit: "Tiền gửi thứ hai",
  deposit_withdrawal_different: "Rút tiền gửi khác nhau",
  ngr: "NGR",
  audit_list: "Danh sách kiểm toán",
  rollback_count: "Đếm ngược",
  rejected_ticket_id: "ID vé bị từ chối",
  rollback: "Quay lại",
  recipient_bank_acc_holder: "Người nắm giữ thẻ ngân hàng nhận",
  reject_date: "Từ chối ngày",
  processing_date: "Ngày xử lý",
  manual_approve: "Phê duyệt (Sổ tay)",
  pending_review_funds: "Vé chờ xử lý và đánh giá",
  table_id: "ID bảng",
  member_label: "Nhãn thành viên",
  label_name: "Tên nhãn",
  label: "Nhãn",
  available_label: "Nhãn có sẵn",
  iframe: "Khung hình",
  iframe_url: "URL khung",
  exchange_rate: "Tỷ giá hối đoái",
  rate: "Tỷ lệ",
  rate_php: "Đánh giá PHP",
  ticket_withdrawal_rollback: "Trở lại rút vé",
  smartico_bonus_report_expired: "Báo cáo tiền thưởng Smartico (Đã hết hạn)",
  reward_type: "Loại phần thưởng",
  turnover_rebate: "Hoàn trả doanh thu",
  turnover_rebate_1: "Cấp VIP",
  turnover_rebate_2: "Tầng doanh thu",
  vip_cycle_day: "Ngày chu kỳ VIP",
  is_addon: "Addon có",
  no_reward: "Không có phần thưởng",
  cash: "Tiền mặt",
  cs: "Dịch vụ khách hàng",
  social_platform: "Nền tảng xã hội",
  edit_vip: "Chỉnh sửa VIP",
  edit_vip_provider: "Chỉnh sửa nhà cung cấp VIP",
  turnover_tier: "Tầng doanh thu",
  rebate_rate: "Tỷ lệ tranh luận",
  edit_turnover_tier: "Chỉnh sửa tầng doanh thu",
  delete_turnover_tier: "Xóa bậc doanh thu",
  vip_log: "Nhật ký VIP",
  member_full_record: "Bản ghi đầy đủ của thành viên",
  before: "Trước",
  after: "Sau đó",
  maintain: "Duy trì",
  actual_rebate: "Hoàn trả thực tế",
  rounded_rebate: "Hoàn trả",
  rebate_mode: "Chế độ tranh luận",
  inbox_id: "ID hộp thư đến",
  rebate_type: "Loại tranh luận",
  promotion_type: "Loại khuyến mãi",
  bonus_rate_1: "Tỷ lệ 1(%)",
  bonus_rate_2: "Tỷ lệ 2(%)",
  bonus_rate_3: "Tỷ lệ 3(%)",
  bonus_rate_4: "Tỷ lệ 4(%)",
  bonus_rate_5: "Tỷ lệ 5(%)",
  bonus_rate_6: "Tỷ lệ 6(%)",
  bonus_rate_7: "Tỷ lệ 7(%)",
  bonus_rate_8: "Tỷ lệ 8(%)",
  bonus_rate_9: "Tỷ lệ 9(%)",
  bonus_rate_10: "Tỷ lệ 10(%)",
  delete_all: "Xóa tất cả",
  rescue_fund: "Quỹ cứu hộ",
  up: "Lên",
  down: "Xuống",
  rate_percent: "Tỷ lệ %",
  cycle: "Chu kỳ",
  actual_amount: "Số tiền thực tế",
  rounded_amount: "Số tiền làm tròn",
  rescue_id: "ID cứu hộ",
  rescue_name: "Tên cứu hộ",
  min_lose: "Thua tối thiểu",
  max_payout: "Trả tiền tối đa",
  payout_method: "Phương thức thanh toán",
  target_group: "Nhóm mục tiêu",
  member_vip_id: "Thành viên ID VIP",
  daily: "Hàng ngày",
  weekly: "Hàng tuần",
  monthly: "Hàng tháng",
  edit_batch: "Chỉnh sửa hàng loạt",
  current_level: "Mức hiện tại",
  next_level: "Cấp độ tiếp theo",
  bet_value: "Giá trị cược",
  line_bet: "Cược dòng",
  total_round: "Total Round",
  audit_by: "Kiểm toán theo",
  possible_next_level: "Cấp độ tiếp theo có thể",
  maintain_deposit: "Duy trì tiền gửi",
  maintain_turnover: "Duy trì doanh thu",
  starting_deposit: "Bắt đầu gửi tiền",
  starting_turnover: "Doanh thu bắt đầu",
  cycle_deposit: "Gửi tiền theo chu kỳ",
  cycle_turnover: "Doanh thu chu kỳ",
  vip_list: "Danh sách VIP",
  up_maintain: "Bảo trì lên",
  down_lowest: "Xuống thấp nhất",
  manual: "Thủ công",
  daily_winlose_game: "Chiến thắng hàng ngày (Trò chơi)",
  actionaff: "Hành động (Liên kết)",
  onload: "đang tải",
  update_status: "Cập nhật trạng thái",
  role_settings: "Cài đặt vai trò",
  customer_services: "Dịch vụ khách hàng",
  marketing: "Tiếp thị",
  finance: "Tài chính",
  payment: "Thanh toán",
  risk_management: "Quản lý rủi ro",
  pt: "PT",
  wallet_history: "Lịch sử ví",
  ticket_amount: "Số tiền vé",
  ignore_risk: "Bỏ qua rủi ro",
  permitted_amount: "Số tiền được phép",
  all_pending_ticket: "Tất cả vé đang chờ xử lý",
  rescue_fund_summary: "Tóm tắt quỹ cứu hộ",
  rescue_fund_summary_daily: "Tóm tắt quỹ cứu hộ hàng ngày",
  rescue_fund_member: "Thành viên Quỹ cứu hộ",
  master: "Chủ nhân",
  account_type: "Loại tài khoản",
  freeze: "Đóng băng",
  domain_member_setup: "Thiết lập tên miền trang web thành viên",
  domain: "Miền",
  domain_list: "Danh sách tên miền",
  domain_application: "Ứng dụng tên miền",
  domain_status: "Trạng thái tên miền",
  domain_group: "Nhóm tên miền",
  operator_id: "ID nhà điều hành",
  domain_type: "Loại tên miền",
  module: "Mô-đun",
  template: "Mẫu",
  custom: "Tùy chỉnh",
  default: "Mặc định",
  payment_provider: "Nhà cung cấp thanh toán",
  payment: "Thanh Toán",
  deactivate: "Không hoạt động",
  name_server: "Máy chủ tên",
  server_account: "Tài khoản máy chủ",
  service_provider: "Nhà cung cấp dịch vụ",
  process: "Quy trình",
  provider_operator: "Nhà điều hành nhà cung cấp",
  bet_limit_member: "@:ui.bet_limit (@:ui.member)",
  global: "Cài đặt toàn cầu",
  second_id: "ID thứ hai",
  unverified: "Chưa được xác minh",
  pt_affiliate: "Phí nền tảng liên kết (%)",
  recipient_bank: "Ngân hàng nhận",
  deposit_type: "Loại tiền gửi",
  security_fund: "Quỹ bảo mật",
  adjust_balance_op: "Điều chỉnh ví điều hành",
  adjust_security_deposit_op: "Điều chỉnh quỹ bảo mật của nhà điều hành",
  marquee: "Marquee",
  marquee_content: "Nội dung Marquee",
  edit_marquee: "Chỉnh sửa Marquee",
  domain_available: "Miền có sẵn",
  daily_withdrawal_frequency: "Tần suất rút tiền hàng ngày",
  maintenance: "Bảo trì",
  max_withdrawal: "Rút tiền tối đa",
  min_balance: "Số dư tối thiểu",
  affiliate_report: "Báo cáo liên kết",
  cash_balance: "Số dư tiền mặt",
  copy_success: "Sao chép thành công!",
  copy_failed: "Sao chép thất bại!",
  your_website: "Trang web của bạn",
  correction_promo: "Sửa chữa(Khuyến mãi)",
  others: "Khác",
  audit_log: "Nhật ký kiểm toán",
  view: "Xem",
  price: "Giá",
  package_level: "Mức đóng gói",
  bo_right: "BO Đúng rồi",
  english: "Tiếng Anh",
  simplified_chinese: "Tiếng Trung (CN)",
  traditional_chinese: "Tiếng Trung (TW)",
  philippine: "Philippines",
  thai: "Thái",
  vietnamese: "Tiếng Việt",
  indonesian: "Indonesia",
  myanmar: "Myanmar",
  japanese: "Tiếng Nhật",
  korean: "Hàn Quốc",
  package_type: "Loại gói",
  full_back_office_access_right: "Quyền truy cập toàn bộ văn phòng hỗ trợ",
  read_only_back_office: "Văn phòng hỗ trợ chỉ đọc",
  language: "Ngôn ngữ",
  lang_code: "Mã ngôn ngữ",
  description: "Mô tả",
  provider_type: "Loại nhà cung cấp",
  logo: "Biểu tượng",
  theme_provider: "Nhà cung cấp chủ đề",
  theme_content: "Nội dung chủ đề",
  content_id: "ID nội dung",
  content_desc: "Mô tả nội dung",
  theme_content_position: "Vị trí nội dung chủ đề",
  theme: "Chủ đề",
  theme_code: "Mã chủ đề",
  theme_name: "Tên chủ đề",
  color: "Màu sắc",
  position: "Vị trí",
  site_name: "Tên trang web",
  theme_color: "Màu chủ đề",
  theme_purchased: "Chủ đề đã mua",
  total_purchased: "Tổng số đã mua",
  purchased_date: "Ngày mua",
  purchase: "Mua",
  total_site: "Tổng số trang web",
  content_setup: "Thiết lập nội dung",
  site_list: "Danh sách trang web",
  site_id: "ID trang web",
  draft_version: "Phiên bản dự thảo",
  prod_version: "Sản phẩm. Phiên bản",
  production_version: "Phiên bản sản xuất",
  info: "Thông tin",
  setting: "Thiết lập",
  site_info: "Thông tin trang web",
  menu: "Menu",
  game_menu: "Thực đơn trò chơi",
  special_menu: "Thực đơn đặc biệt",
  setting_menu: "Thực đơn cài đặt",
  error: "Lỗi",
  sync_all: "Đồng bộ hóa tất cả",
  theme_content_group: "Nhóm nội dung chủ đề",
  content_group: "Nhóm nội dung",
  content_group_desc: "Nhóm nội dung Desc",
  parent_content_id: "ID nội dung gốc",
  bo_default_domain: "Miền mặc định BO",
  domain_id: "ID miền",
  deactive: "Hoạt động",
  site_sync: "Đồng bộ hóa trang web",
  upload: "Tải lên",
  comingSoon: "Sắp ra mắt",
  profile_setting: "Cài đặt hồ sơ",
  bank: "Ngân hàng",
  company: "Công ty",
  own: "SỞ HỮU",
  operator_setting: "Cài đặt nhà điều hành",
  external_id: "ID bên ngoài",
  ticket: "Vé",
  bank_owner: "Chủ ngân hàng",
  exchanged_currency: "Tiền tệ trao đổi",
  company_bank_owner: "Chủ ngân hàng công ty",
  ticket_list_member: "Danh sách vé (Thành viên)",
  game_name_exclude: "Loại trừ tên trò chơi",
  tab: "Tab",
  about_us: "Giới thiệu về chúng tôi",
  privacy_policy: "Chính sách bảo mật",
  responsible_gaming: "Trò chơi có trách nhiệm",
  banking: "Ngân hàng",
  faqs: "Câu hỏi thường gặp",
  advertisement: "Quảng cáo",
  px_pixel_id: "ID pixel PX",
  px_token: "Mã thông báo PX",
  af_dev_key: "Khóa Af Dev",
  af_apps_id: "ID ứng dụng Af",
  pp_tid: "PP TID",
  pp_pid: "PP PID",
  pp_aid: "HỖ TRỢ PP",
  gtm_id: "ID GTM",
  service_provider_url: "URL của nhà cung cấp dịch vụ",
  script_inject: "Tiêm tập lệnh",
  head_script: "Kịch bản chính",
  body_script: "Kịch bản cơ thể",
  ads_id: "ID quảng cáo",
  member_detail: "Chi tiết thành viên",
  memberreport: "Báo cáo thành viên",
  member_log: "Nhật ký thành viên",
  general: "Tướng quân",
  top_theme: "Chủ đề hàng đầu",
  hot_game: "Trò chơi nóng",
  hot_list: "Danh sách nóng",
  new_game: "Trò chơi mới",
  popular_game: "Trò chơi phổ biến",
  featured_game: "Trò chơi nổi bật",
  new_list: "Danh sách mới",
  popular_list: "Danh sách phổ biến",
  featured_list: "Danh sách nổi bật",
  provider_new_game: "Trò chơi mới của nhà cung cấp",
  provider_popular_game: "Trò chơi phổ biến của nhà cung cấp",
  provider_featured_game: "Trò chơi nổi bật của nhà cung cấp",
  website: "Trang web",
  site_customization: "Tùy chỉnh trang web",
  export_all: "Xuất khẩu tất cả",
  export_one: "Xuất (Trang hiện tại)",
  daily_ledger: "Sổ cái hàng ngày",
  daily_ledger_member: "Sổ cái hàng ngày (Thành viên)",
  promotion_signup_unused: "Khuyến mãi đăng ký chưa sử dụng",
  promotion_signup_ongoing: "Khuyến mãi đăng ký đang diễn ra",
  promotion_signup_winlose: "Đăng ký khuyến mãi Winlose",
  promotion_signup_winlose_operator: "Đăng ký khuyến mãi Winlose (Người điều hành)",
  promotion_signup_winlose_member: "Đăng ký khuyến mãi Winlose (Thành viên)",
  total_player_balance: "Tổng số dư người chơi",
  search_all: "Tìm kiếm tất cả",
  mbsetting: "Cài đặt",
  todays_highlights: "Những điểm nổi bật của ngày hôm nay",
  deposit_player: "Người chơi gửi tiền",
  withdrawal_player: "Người chơi rút tiền",
  kill_rate: "Tỷ lệ tiêu diệt",
  login_player: "Người chơi đăng nhập",
  operation_management: "Chiến dịch",
  game_management: "Trò chơi",
  member_management: "Thành viên",
  affiliate_management: "Liên kết",
  promotion_management: "Khuyến mãi",
  mbcampaign: "Chiến dịch",
  promo_allday: "Cả ngày",
  promo_daily: "Hàng ngày",
  promo_daily_first_deposit: "Tiền gửi đầu tiên hàng ngày",
  promo_deposit_monthly: "Số tiền gửi hàng tháng",
  promo_deposit_signup: "Đăng ký đếm tiền gửi",
  promo_deposit_weekly: "Số tiền gửi hàng tuần",
  promo_newbie: "Người mới",
  promo_once: "Một lần",
  dd_review: "Đánh giá",
  game_provider_management: "Nhà cung cấp",
  exchanged_amount: "Số tiền trao đổi",
  operator_summary: "Tóm tắt người vận hành",
  business_id: "ID doanh nghiệp",
  game_name_exclude_log: "Tên trò chơi loại trừ nhật ký",
  cn: "CN",
  local: "ĐỊA PHƯƠNG",
  taken: "Đã chụp",
  receiver_bank: "Ngân hàng thu",
  receiver_bank_acc_no: "Ngân hàng thu Acc số",
  receiver_bank_acc_holder: "Người nắm giữ thẻ ngân hàng thu",
  add_balance: "Thêm số dư",
  deduct_balance: "Số dư khấu trừ",
  sync_site_content: "Đồng bộ hóa nội dung trang web",
  payment_setting: "Thiết lập thanh toán",
  payment_own: "SỞ HỮU",
  payment_global: "TOÀN CẦU",
  livechat: "Trò chuyện trực tiếp",
  chat_id: "Khóa giấy phép LiveChat",
  chat_provider: "Nhà cung cấp LiveChat",
  auto_cycle: "CHU KỲ",
  auto_all: "TẤT CẢ",
  completed_amount: "Số tiền đã hoàn tất",
  website_launched: "Trang web đã được khởi chạy",
  total_operators: "Tổng số nhà điều hành",
  today_active: "Hoạt động hôm nay",
  new_player_verified_signup: "Người chơi mới đã xác minh/đăng ký",
  total_players: "Tổng số người chơi",
  depo_withdrawal_diff: "Chênh lệch GỬI-RÚT",
  claim_count: "Số lượt yêu cầu",
  ggr: "GGR",
  member_balance: "Số dư thành viên",
  players: "Người chơi",
  provider_pt: "Nhà cung cấp PT",
  base: "Cơ sở",
  topup_id: "ID Nạp tiền",
  credential: "Thông tin xác thực",
  credential_1: "Thông tin xác thực 1",
  credential_2: "Thông tin xác thực 2",
  credential_3: "Thông tin xác thực 3",
  credential_4: "Thông tin xác thực 4",
  credential_5: "Thông tin xác thực 5",
  credential_6: "Thông tin xác thực 6",
  credential_7: "Thông tin xác thực 7",
  credential_8: "Thông tin xác thực 8",
  credential_9: "Thông tin xác thực 9",
  credential_10: "Thông tin xác thực 10",
  limit: "Giới hạn",
  create: "Tạo",
  hint: "Gợi ý",
  quickSetup: "Thiết lập nhanh",
  next: "Tiếp theo",
  setUpTheme: "Cài đặt chủ đề",
  checkOut: "Kiểm tra",
  standardPackage: "Gói tiêu chuẩn",
  siteName: "Tên trang web",
  information: "Thông tin",
  useThisTemplate: "Sử dụng mẫu này",
  summary: "Tóm tắt",
  createOperatorAccount: "Tạo tài khoản quản trị",
  operatorId: "ID quản trị",
  operatorPwd: "Mật khẩu quản trị",
  new_website: "Trang web mới",
  operator_information: "Thông tin Nhà vận hành",
  bo_link: "Liên kết Backend",
  daily_summary_sms: "Tóm tắt SMS hàng ngày",
  daily_summary_sms_operator: "Tóm tắt SMS hàng ngày của nhà điều hành",
  daily_summary_sms_operator_detail: "Chi tiết tóm tắt SMS hàng ngày của nhà điều hành",
  sms_count: "Số lượng SMS",
  provider_winlose_operator_pt: "Nhà cung cấp Winlose (Nhà điều hành PT)",
  pt_on: "PT là",
  share_operator: "Người vận hành chia sẻ",
  share_company: "Công ty chia sẻ",
  token_log: "Nhật ký mã thông báo",
  template_code: "Mã Mẫu",
  template_name: "Tên Mẫu",
  mini_game: "Trò Chơi Nhỏ",
  max_game_reward: "Phần Thưởng Tối Đa",
  max_chance_per_day: "Cơ Hội Tối Đa Mỗi Ngày",
  is_recurring_chance: "Lặp Lại",
  token_request: "Token",
  enabled: "Đã Bật",
  disabled: "Đã Tắt",
  unlimited: "Không Giới Hạn",
  max_chance_unlimited: "Cơ Hội Tối Đa Mỗi Ngày Không Giới Hạn",
  mini_game_template: "Mẫu Trò Chơi Nhỏ",
  reward_code: "Mã Phần Thưởng",
  reward_name: "Tên Phần Thưởng",
  reward_description: "Mô Tả Phần Thưởng",
  reward_probability: "Xác Suất Nhận Phần Thưởng",
  total_game: "Tổng Số Trò Chơi",
  total_played_mini_game: "Tổng Số Trò Chơi Mini Đã Chơi",
  total_played_mini_game_detail: "Chi Tiết Tổng Số Trò Chơi Mini Đã Chơi",
  total_played_mini_game_detail_operator: "Chi Tiết Tổng Số Trò Chơi Mini Đã Chơi (Nhà điều hành)",
  daily_pnl_operator: "P&L Hằng Ngày (Nhà điều hành)",
  token: "Token",
  token_1: "Token 1",
  token_2: "Token 2",
  token_3: "Token 3",
  token_4: "Token 4",
  token_5: "Token 5",
  token_6: "Token 6",
  token_7: "Token 7",
  cash_1: "Tiền mặt 1",
  cash_2: "Tiền mặt 2",
  cash_3: "Tiền mặt 3",
  cash_4: "Tiền mặt 4",
  cash_5: "Tiền mặt 5",
  cash_6: "Tiền mặt 6",
  cash_7: "Tiền mặt 7",
  daily_login: "Điểm danh hàng ngày (Đăng nhập hàng ngày)",
  daily_login_update: "Cập nhật điểm danh hàng ngày (Đăng nhập hàng ngày)",
  game_result_reward: "Phần thưởng kết quả trò chơi",
  current_streak: "Chuỗi Hiện Tại",
  login_streak: "Chuỗi Đăng Nhập",
  total_token: "Tổng số Token",
  total_mini_game_token_used: "Tổng số Token Mini Game đã sử dụng",
  total_mini_game_token_used_detail: "Chi tiết tổng số Token Mini Game đã sử dụng",
  total_mini_game_token_used_detail_operator: "Chi tiết tổng số Token Mini Game đã sử dụng (Nhà điều hành)",
  total_reward: "Tổng phần thưởng",
  total_mini_game_reward: "Tổng phần thưởng Mini Game",
  total_mini_game_reward_detail: "Chi tiết tổng phần thưởng Mini Game",
  total_mini_game_reward_detail_operator: "Chi tiết tổng phần thưởng Mini Game (Nhà điều hành)",
  token_balance: "Số dư Token",
  free_game_token: "Token Trò chơi miễn phí",
  bo_url: "URL Văn phòng quản trị",
  copied: "Đã sao chép",
  callback: "Gọi lại (Callback)",
  api: "API",
  prefix: "Tiền tố",
  delimiter: "Dấu phân cách",
  url_callback_deposit: "URL Gọi lại Nạp tiền",
  url_callback_withdrawal: "URL Gọi lại Rút tiền",
  url_callback_affiliate: "URL Gọi lại Đối tác",
  url_api_deposit: "URL Gọi lại Nạp tiền (API)",
  url_api_withdrawal: "URL Gọi lại Rút tiền (API)",
  url_api_balance: "URL Gọi lại Số dư (API)",
  prefix_deposit: "Tiền tố Nạp tiền",
  prefix_withdrawal: "Tiền tố Rút tiền",
  prefix_affiliate: "Tiền tố Đối tác",
  prefix_delimiter: "Dấu phân cách Tiền tố",
  merchant: "Thương gia",
  app_id: "ID Ứng dụng",
  secret_key: "Khóa bí mật",
  deposit_secret_key: "Khóa bí mật gửi tiền",
  withdrawal_secret_key: "Khóa bí mật rút tiền",
  partners: "Đối tác",
  partner_name: "Tên đối tác",
  win: "Thắng",
  manifest: "Danh sách",
  crop: "Cắt",
  cropImage: "Cắt ảnh",
  api_url : "URL của API",
  authentication_key: "Khóa xác thực",
  one_week: "1 tuần",
  two_week: "2 tuần",
  one_month: "1 tháng",
  two_month: "2 tháng",
  six_month: "6 tháng",
  edit_promotion_end_date: "Chỉnh sửa ngày kết thúc khuyến mãi",
  android_app_link: "Liên kết ứng dụng Android",
  add_android_app_link: "Thêm liên kết ứng dụng Android"
}